// Mock data for Forge Stays — Comfortable Anglesey Stays
// Only owner-supplied photography is used across the site.

export const BOOKING_URL = "https://book.forgestays.co.uk";

export const LOGO_URL = "https://customer-assets-39nsmqrw.emergentagent.net/job_42f80651-3900-4bc7-80b3-5a09093a96e1/artifacts/8f2g3ima_WhatsApp%20Image%202026-07-16%20at%2011.28.48.jpeg";

// Owner-supplied photography
export const OWNER = {
  // Hotel Cymyran (Valley)
  cymyran_exterior: "https://customer-assets-39nsmqrw.emergentagent.net/job_forge-living/artifacts/tgyz05jv_Screenshot%202026-07-16%20130812.png",
  cymyran_lodge:    "https://customer-assets-39nsmqrw.emergentagent.net/job_forge-living/artifacts/nq6hinao_WhatsApp%20Image%202026-07-24%20at%2012.54.42.jpeg",
  cymyran_bedroom:  "https://customer-assets-39nsmqrw.emergentagent.net/job_forge-living/artifacts/mln9qasz_Screenshot%202026-07-16%20142833.png",
  cymyran_bedroom2: "https://customer-assets-39nsmqrw.emergentagent.net/job_forge-living/artifacts/20k3n3yt__DSC9766.jpg",
  cymyran_kitchen:  "https://customer-assets-39nsmqrw.emergentagent.net/job_forge-living/artifacts/8bdqolbt__DSC9754.jpg",
  cymyran_bathroom: "https://customer-assets-39nsmqrw.emergentagent.net/job_forge-living/artifacts/dkjssprf__DSC9799.jpg",
  cymyran_living1:  "https://customer-assets-39nsmqrw.emergentagent.net/job_42f80651-3900-4bc7-80b3-5a09093a96e1/artifacts/uao8tcpj_Use%20AI%20Image%20Jul%2016%2C%202026%2C%2011_20_03.png",
  cymyran_living2:  "https://customer-assets-39nsmqrw.emergentagent.net/job_42f80651-3900-4bc7-80b3-5a09093a96e1/artifacts/vxxr2oxv_Use%20AI%20Image%20Jul%2016%2C%202026%2C%2011_20_09.png",
  // Newry Street (Holyhead)
  newry_living:     "https://customer-assets-39nsmqrw.emergentagent.net/job_forge-living/artifacts/7horip14_20260717_094307.webp",
  newry_bedroom:    "https://customer-assets-39nsmqrw.emergentagent.net/job_forge-living/artifacts/7w5al2ft_bedroom8.png",
  newry_bedroom2:   "https://customer-assets-39nsmqrw.emergentagent.net/job_forge-living/artifacts/ksez65re_ChatGPT%20Image%20Jul%2017%2C%202026%2C%2004_31_57%20PM.png"
};

// Hero background — the striking Newry Street blue-sofa living room
export const HERO_IMAGE = OWNER.newry_living;

export const GALLERY_IMAGES = [
  { src: OWNER.newry_living,     alt: "Newry Street living room",         caption: "Newry Street, Holyhead — living room" },
  { src: OWNER.newry_bedroom,    alt: "Newry Street bedroom",             caption: "Newry Street — bedroom with garden view" },
  { src: OWNER.cymyran_exterior, alt: "Hotel Cymyran Lodge exterior",      caption: "The Lodge at Hotel Cymyran, Valley" },
  { src: OWNER.cymyran_living1,  alt: "Open plan living with vaulted ceiling", caption: "Open-plan living at The Lodge" },
  { src: OWNER.cymyran_living2,  alt: "Bright living room with skylights",  caption: "Sun-lit communal space at The Lodge" },
  { src: OWNER.cymyran_bedroom,  alt: "Comfortable en-suite bedroom",       caption: "Comfortable bedrooms at Cymyran" },
  { src: OWNER.cymyran_bedroom2, alt: "En-suite bedroom with countryside view", caption: "Restful rooms with garden views" },
  { src: OWNER.cymyran_kitchen,  alt: "Fully-equipped modern kitchen",      caption: "Full kitchens — cook in or dine out" },
  { src: OWNER.cymyran_bathroom, alt: "Modern en-suite bathroom",           caption: "Modern en-suite bathrooms" }
];

// Audience-focused: contractors/consultants + holiday guests + hosts
export const AUDIENCES = [
  {
    key: "work",
    icon: "Briefcase",
    title: "Contractors & Consultants",
    desc: "A short drive from RAF Valley, the Port of Holyhead and the local business parks. Reliable Wi-Fi, private en-suite rooms, on-site parking and flexible long-stay rates — the perfect base while you work."
  },
  {
    key: "holiday",
    icon: "TreePalm",
    title: "Holidaymakers",
    desc: "Coastal walks straight from the door, Snowdonia in the distance and Anglesey's best beaches minutes away. A relaxed base for families, groups and getaways."
  },
  {
    key: "hosts",
    icon: "Building2",
    title: "Holiday-Let Makers",
    desc: "Bulk-book rooms or whole properties for teams, viewings and turnover crews. Flexible arrangements and monthly rates available."
  }
];

export const FEATURES = [
  { icon: "MapPin",           title: "Across Anglesey",        desc: "Properties in Valley and Holyhead — pick your base" },
  { icon: "Mountain",         title: "Snowdonia & Sea Views",  desc: "Beautiful scenery a short walk or drive away" },
  { icon: "BedDouble",        title: "En-suite Comfort",       desc: "Private, contemporary rooms in every property" },
  { icon: "Home",             title: "Full Kitchens",          desc: "Cook in comfort or explore Anglesey's food scene" },
  { icon: "Wifi",             title: "High-Speed Wi-Fi",       desc: "Reliable connection for remote work or streaming" },
  { icon: "CalendarClock",    title: "Long Stays Welcome",     desc: "Weekly & monthly rates for extended visits" },
  { icon: "Car",              title: "Free Parking",           desc: "On-site or on-street parking at every property" },
  { icon: "Dog",              title: "Dog-Friendly",           desc: "Bring your four-legged friend along" },
  { icon: "Sparkles",         title: "Immaculately Presented", desc: "Professionally cleaned before every stay" },
  { icon: "Coffee",           title: "Coffee & Tea Bar",       desc: "Everything you need to start the morning" },
  { icon: "Tv",               title: "Smart TVs",              desc: "Cast your favourites on the big screen" },
  { icon: "ShieldCheck",      title: "Trusted Hosts",          desc: "Locally owned and personally cared for" }
];

// The Forge Stays properties across Anglesey
export const PROPERTIES = [
  {
    key: "cymyran-townhouses",
    name: "Cymyran Terrace Townhouses",
    location: "Valley, Anglesey",
    status: "Now Available",
    subtitle: "5 × entire 3-bedroom en-suite townhouses",
    description:
      "Five entire three-bedroom townhouses on Cymyran Terrace, each with three en-suite bedrooms and a large open-plan living kitchen. Perfect for families, group getaways or contractor teams — book one or the whole terrace.",
    highlights: ["3 en-suite bedrooms", "Open-plan living kitchen", "Whole-house rentals", "Book one or all five"],
    image: OWNER.cymyran_living1,
    images: [OWNER.cymyran_living1, OWNER.cymyran_living2, OWNER.cymyran_bedroom, OWNER.cymyran_kitchen],
    cta: "Book Cymyran Terrace"
  },
  {
    key: "newry",
    name: "Newry Street",
    location: "Holyhead, Anglesey",
    status: "Now Available",
    subtitle: "Stylish townhouse stay in Holyhead centre",
    description:
      "A characterful, thoughtfully styled townhouse just moments from Holyhead's high street, the port and the Anglesey coast path. Comfortable, contemporary and ideal for short breaks or longer working stays.",
    highlights: ["Central Holyhead", "Comfortable double bedrooms", "Fully-equipped kitchen", "Smart TV & fast Wi-Fi"],
    image: OWNER.newry_living,
    images: [OWNER.newry_living, OWNER.newry_bedroom],
    cta: "Book Newry Street"
  },
  {
    key: "lodge",
    name: "The Lodge · Hotel Cymyran",
    location: "Valley, Anglesey",
    status: "Opening Soon",
    subtitle: "9 en-suite bedrooms · Opening in around a month",
    description:
      "A newly refurbished nine-bedroom lodge just a few steps from the main hotel. Comfortable, contemporary en-suite rooms with generous open-plan living — ideal for contractors, project teams and holidaymakers alike.",
    highlights: ["9 en-suite bedrooms", "Open-plan communal living", "Free on-site parking", "Long-stay rates"],
    image: OWNER.cymyran_lodge,
    images: [OWNER.cymyran_lodge, OWNER.cymyran_exterior, OWNER.cymyran_living1, OWNER.cymyran_bedroom],
    cta: "Register Interest"
  },
  {
    key: "hotel",
    name: "Hotel Rooms · Hotel Cymyran",
    location: "Valley, Anglesey",
    status: "Coming Soon",
    subtitle: "Boutique rooms in the main hotel",
    description:
      "Our beautifully reimagined hotel rooms are on the way. Stylish, comfortable spaces with the same warm Cymyran welcome, an on-site brasserie and bar, and easy access to Valley, the coast and RAF Valley.",
    highlights: ["Boutique styling", "On-site brasserie & bar", "Snowdonia & sea views", "Family-run hospitality"],
    image: OWNER.cymyran_bedroom2,
    images: [OWNER.cymyran_bedroom2, OWNER.cymyran_bathroom],
    cta: "Notify Me"
  }
];

export const REVIEWS = [
  {
    name: "Mark",   location: "Contractor · RAF Valley project", date: "May 2026",
    text: "I stay for weeks at a time and Forge Stays is by far the best base I've found near the base. Comfortable rooms, solid Wi-Fi and a proper kitchen make a huge difference on a long project."
  },
  {
    name: "Sarah",  location: "Manchester, UK · Holiday", date: "April 2026",
    text: "A truly special stay. The setting is breathtaking — Snowdonia on one side, the Anglesey coast on the other. The team could not have been more welcoming."
  },
  {
    name: "James",  location: "London, UK · Newry Street", date: "March 2026",
    text: "The Newry Street house is beautifully done — a really stylish base for exploring Holyhead and the coast. We'll be back."
  },
  {
    name: "Alex",   location: "Consultant · North Wales", date: "February 2026",
    text: "The perfect stop-off between client sites. Easy parking, comfortable rooms, and enough space to actually unwind after a long day."
  }
];

export const CONTACT = {
  email: "sarah@findyourferal.co",
  phone: "07939 520060",
  phoneRaw: "+447939520060",
  address_line1: "Plas Llechylched",
  address_line2: "Bryngwran, Anglesey",
  address_line3: "LL65 3SH",
  whatsapp: "https://wa.me/447939520060?text=Hi%2C%20I%27d%20like%20to%20enquire%20about%20Forge%20Stays",
  instagram: "https://www.instagram.com/findyourferal.co/",
  facebook: "https://www.facebook.com/findyourferal.co"
};

export const FERAL = {
  name: "Feral",
  url: "https://feraltribe.co.uk",
  logo: "https://customer-assets-39nsmqrw.emergentagent.net/job_forge-living/artifacts/k8d9h9p2_Assets_brand%20mark%20teal.png"
};
